import Cookies from "js-cookie";
const ID_TOKEN_KEY = "id_token" as string;

export const getTopLevelDomain = () => {
  const host = window.location.host; // 获取当前的域名或 IP 地址，例如：192.168.1.1 或 www.example.com
  const parts = host.split("."); // 将域名或 IP 地址通过 . 分隔，拆分成数组
  let topLevelDomain;
  if (parts.length === 4 && /^\d+\.\d+\.\d+\.\d+$/.test(host)) {
    // 如果域名或 IP 地址为 IP 地址，则直接返回该地址
    topLevelDomain = host;
  } else if (host === "localhost") {
    // 如果域名为 localhost，则直接返回该域名
    topLevelDomain = host;
  } else {
    // 否则获取最后两部分，即顶级域名和一级域名
    topLevelDomain = parts.slice(-2).join(".");
  }
  return topLevelDomain;
};

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  let token;
  const lin_passport = Cookies.get("lin_passport");
  if (lin_passport != null) {
    const passport = JSON.parse(lin_passport);
    token = "token" in passport ? passport.token : "";
  }
  if (!token) {
    //token = window.localStorage.getItem(ID_TOKEN_KEY);
  }
  return token;
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string): void => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
  Cookies.remove("lin_passport", { path: "/", domain: getTopLevelDomain() });
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export default { getToken, saveToken, destroyToken };
